import { Component, OnInit, ChangeDetectionStrategy, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { of } from 'rxjs';
import { delay, take, switchMap, filter, tap } from 'rxjs/operators';
import { Document } from 'src/app/acl-data/document/document.dto';
import { DocumentService } from 'src/app/acl-data/document/document.service';

export interface IPreviewData {
  document: Document;
  objectStore: string;
}

@Component({
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentPreviewComponent {
  @ViewChild('thumbnailImg', { static: false }) thumbnailImg;

  filenetURL = environment.filenetURL;

  thumbnailWait = false;

  document$ = this.documentService.displayById(this.data.document.id);

  linkedDocuments$ = this.document$.pipe(
    filter(v => v && v.linkedDocuments && v.linkedDocuments.length > 0),
    switchMap(v => this.documentService.getByIds(this.data.objectStore, v.linkedDocuments))
  );

  constructor(
    private documentService: DocumentService,
    public snakbarRef: MatSnackBarRef<DocumentPreviewComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: IPreviewData
  ) {
    if (!data.document.complete) {
      console.log('Document not complete fetching');
      this.documentService
        .getByID(data.objectStore, data.document.id, true)
        .pipe(take(1))
        .subscribe(_ => {
          return;
        });
    }
  }

  dismiss() {
    this.snakbarRef.dismiss();
  }

  thumbnailError() {
    console.log('Thumbnail not yet available');
    this.thumbnailWait = true;
    of('Request Complete!')
      .pipe(delay(30000))
      .subscribe(() => (this.thumbnailWait = false));
  }

  copyMessage(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    let location = window.location.href;
    if (location.indexOf('#') >= 0) {
      location = location.substring(0, location.indexOf('#'));
    }
    selBox.value = location + '#' + val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
}
